import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';

import { useEditIncentivesMarketSharePurchaseContractTemplateModal } from '../context/EditIncentivesMarketSharePurchaseContractTemplateModalContext';

const EditIncentivesMarketSharePurchaseContractTemplateModalHeader: FC = () => {
  const { t } = useTranslate();
  const { actions } = useEditIncentivesMarketSharePurchaseContractTemplateModal();

  return (
    <Modal.Header className="border-bottom">
      <h5 className="modal-title mb-0">
        <em className="icon ni ni-edit mr-2" />
        {t('EditIncentivesMarketSharePurchaseContractTemplateTitle')}
      </h5>
      <button
        type="button"
        className="close"
        onClick={actions.handleCloseModal}
        aria-label={t('Close')}
      >
        <em className="icon ni ni-cross" />
      </button>
    </Modal.Header>
  );
};

export default EditIncentivesMarketSharePurchaseContractTemplateModalHeader;
